import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61d7d7e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_3 = { class: "col-6 example-pagination-block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        "current-page": _ctx.currentPage,
        total: _ctx.total,
        "page-size": _ctx.pageSize,
        "pager-count": _ctx.pagerCount,
        "default-page-size": _ctx.pageSize,
        onCurrentChange: _ctx.change
      }, null, 8, ["current-page", "total", "page-size", "pager-count", "default-page-size", "onCurrentChange"])
    ]),
    _hoisted_4
  ]))
}